import React, { useEffect, useState } from "react";
import Modal from "./Modal";

function UrgentRequestModal({
  isOpen,
  onClose,
  onSubmit,
  stageList = [],
  title = "Request URGENT",
}) {
  const [stage, setStage] = useState("");

  useEffect(() => {
    if (!isOpen) setStage("");
  }, [isOpen]);

  const disabled = !stage;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-4">
        <h4 className="mb-3">{title}</h4>

        <div className="mb-3">
          <label htmlFor="urgentStage" className="form-label">
            Select Stage for URGENT:
          </label>
          <select
            id="urgentStage"
            className="form-select"
            value={stage || ""}
            onChange={(e) => setStage(e.target.value)}
          >
            <option value="" disabled>
              -- Select --
            </option>
            {stageList.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>

        <div className="d-flex justify-content-end">
          <button className="btn btn-secondary me-2" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-danger"
            disabled={disabled}
            onClick={() => onSubmit(stage)}
          >
            Request URGENT
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default UrgentRequestModal;